module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_6005.6cc0186c.png";